module.exports = __webpack_public_path__ + "media/assets/images/direction-icon-86934b526eda2ce32b5dfd0026525b84.svg";